import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-top-games',
  templateUrl: './app-top-games.component.html',
  styleUrls: ['./app-top-games.component.scss']
})
export class AppTopGamesComponent {

  @Input()
  langCode: any = "en";
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  
  constructor(
    private router: Router,
  ) { }

  goToGames(gameTab){
    this.router.navigate([this.langCode,'allgames'], { queryParams: {gameTab:gameTab} });
  }

}
